import { Button } from 'components/Button';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useEffect } from 'react';
import { blinkPageTitle } from 'helpers/utils';

interface Props extends DialogProps {
  onClose: () => void;
}

export const AudioEnableInteractionModal: React.FC<Props> = ({
  onClose,
  ...props
}) => {
  useEffect(() => {
    blinkPageTitle('Ativar notificações audíveis.');
  }, [props.open]);

  return (
    <Dialog {...props}>
      <DialogTitle>Ativar notificações audíveis</DialogTitle>

      <DialogContent>
        <Typography>Para receber notificações audíveis,</Typography>
        <Typography>
          você precisa clicar em
          <span style={{ fontWeight: 'bold' }}> Continuar</span>
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button variant="contained" onClick={onClose} fullWidth>
          Continuar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
